export default __webpack_public_path__ + "static/media/arrowRightDirection.79ec0037.svg";